import { render, staticRenderFns } from "./LanghamFooter.vue?vue&type=template&id=72c3a8ec&"
import script from "./LanghamFooter.vue?vue&type=script&lang=js&"
export * from "./LanghamFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports